module.exports = __webpack_public_path__ + "img/t2_flt_pt_wing_bolt.prt.0bac5fc0.jpg";